import './lighten.scss';
(function ($, Drupal, drupalSettings) {
    Drupal.behaviors.lighten = {
      attach: function(context) {
        for (const t of $('.field-multiple-table').toArray()) {
          $(t).parent().attr('table-items-count', $(t).children('tbody').children().length);
  
        }
      }
    }
})(jQuery, Drupal, drupalSettings);
